export default "__VITE_ASSET__Czk2uOEH__"